const AttorneyAgentIndividsQuery = (id) => {
    return `
    query {
        getAgentProfileById(id: "${id}") {
          id
          group_id,
          form_id,
          user_id,
          AgentProfileFormData {
            new_profile_atty_agent_dba
            new_profile_atty_agent_fein
            new_profile_atty_agent_profile_name
          }
        }
      }
      `
}

export default AttorneyAgentIndividsQuery